




















































import _ from 'lodash';
import Vue from 'vue';
import moment from 'moment';
import VClamp from 'vue-clamp';
import ProductState, {
  getProductStateColor,
} from '@/core/typings/enums/ProductState';
import { mapGetters } from 'vuex';
import { getProductTypeTranslations } from '@/core/utils/products';
import ProductThumbnail from '@/web/components/products/ProductThumbnail.vue';

export default Vue.extend({
  name: 'StudioProductCard',
  components: { VClamp, ProductThumbnail },
  props: {
    product: {
      type: Object as () => ProductResponse,
      required: true,
    },
    displayPricing: {
      type: Boolean,
      default: true,
    },
    static: {
      // removes any pricing information
      type: Boolean,
      default: false,
    },
    isSelectable: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    animated: {
      type: Boolean,
      default: true,
    },
    isGift: {
      type: Boolean,
      default: false,
    },
    fullSize: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    date: function (value: string): string {
      if (!value) return '';
      return moment(value).format('MMM DD, yyyy');
    },
  },
  computed: {
    ...mapGetters({
      currency: 'studio/currency',
    }),
    color(): string {
      return getProductStateColor(this.product.productState);
    },
    getProductType() {
      return getProductTypeTranslations(this.product.product_type);
    },
    getPricingText() {
      if (!this.displayPricing) {
        return null;
      }
      if (this.product.pricing_type === 'free') {
        return this.$t('PRODUCTS.LABELS.FREE');
      }
      if (this.product.pricing_type === 'fixed') {
        return this.$formatCurrency(this.product.price || 0, this.currency);
      }
      if (this.product.pricing_type === 'recurring') {
        let pricingText;
        let period;
        if (this.product.recurring_type !== 'multiple') {
          period = this.$t(
            `PRODUCTS.LABELS.RECURRING_${this.product.recurring_type.toUpperCase()}`
          );
          pricingText = `${this.$formatCurrency(
            this.product.price || 0,
            this.currency
          )}`;
        } else {
          const prefix = this.$t('PRODUCTS.LABELS.FROM');
          const arr = _.values(
            _.transform(
              this.product.recurring_options,
              (result, value, key) => {
                result[key] = { ...value, period: key };
              }
            )
          );
          const onlyAvailable = arr.filter(opt => opt.available);
          const lowestOption = _.minBy(onlyAvailable, option =>
            parseFloat(option.price)
          );
          period = this.$t(
            `PRODUCTS.LABELS.RECURRING_${lowestOption.period.toUpperCase()}`
          );
          pricingText = `${prefix} ${this.$formatCurrency(
            lowestOption.price || 0,
            this.currency
          )}`;
        }

        if (this.isGift) {
          return pricingText;
        } else {
          return `${pricingText}/${period}`;
        }
      }
      return 'ERROR';
    },
    hidePrice() {
      return this.static || this.product.purchased;
    },
    showWishPriceEnabled() {
      return this.product.wish_price_enabled && !this.hidePrice && !this.isGift;
    },
    hasTags() {
      return this.product?.tags?.length;
    },
  },
  methods: {
    tagClicked(tag) {
      console.log(tag);
      window.alert(tag.name);
    },
  },
});
